export default __webpack_public_path__ + "static/media/mask.fbc5f488.svg";